import {Component, OnInit} from '@angular/core';
import {Select} from '@ngxs/store';
import {AppState} from '../../state/appState';
import {Observable} from 'rxjs';
import {AppStateConfigModel} from '../../state/appState.model';
import {GatewayConfigModel} from '../../shared/services/gateway-config/gatewayConfig.model';
import packageInfo from '../../../../package.json';

@Component({
  selector: 'app-debug',
  templateUrl: './debug.component.html',
  styleUrls: ['./debug.component.scss']
})
export class DebugComponent implements OnInit {

  constructor() { }
  @Select(AppState.config$) config$: Observable<AppStateConfigModel>;
  @Select(AppState.gatewayConfig$) gatewayConfig$: Observable<GatewayConfigModel>;
  public appVersion = packageInfo.version;

  ngOnInit(): void {
  }
}
